import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Copy, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { fmtDate } from "@/lib/finance";
import { Section } from "@/components/common/DetailFields";

const STATS = [["enviadas", "Enviadas"], ["abiertas", "Abiertas"], ["registradas", "Registradas"], ["activadas", "Activadas"]];

const status = (i) => (i.activada_en ? "Activó su red" : i.registrada_en ? "Se registró" : i.abierta_en ? "Abrió la liga" : "Enviada");

export default function InvitacionesPage() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/red/invitaciones").then((r) => setD(r.data)).catch((e) => toast.error(errMsg(e))); }, []);
  if (!d) return <div className="py-16 flex justify-center"><Loader2 className="w-6 h-6 animate-spin c-muted" /></div>;
  const copy = async () => { try { await navigator.clipboard.writeText(d.liga); toast.success("Liga copiada"); } catch { toast.error("No se pudo copiar"); } };
  return (
    <div data-testid="invitaciones-page" className="space-y-3">
      <div className="c-card p-4 space-y-1">
        <p className="text-xs c-muted">Invitaciones disponibles</p>
        <p data-testid="invitaciones-disponibles" className="font-heading text-4xl font-extrabold">{d.ilimitadas ? "Ilimitadas" : d.disponibles}</p>
        <p className="text-xs c-text-2">Ganas {d.bono_activacion} más por cada invitado que active su red.</p>
      </div>
      <div className="grid grid-cols-4 gap-2">
        {STATS.map(([k, label]) => (
          <div key={k} className="c-card p-2.5 text-center">
            <p data-testid={`invitaciones-stat-${k}`} className="font-heading text-xl font-extrabold tabular-nums">{d.resumen[k]}</p>
            <p className="text-[10px] c-text-2">{label}</p>
          </div>
        ))}
      </div>
      <div className="c-card p-3 flex items-center gap-2">
        <p data-testid="invitaciones-liga" className="flex-1 text-xs font-mono truncate">{d.liga}</p>
        <button data-testid="invitaciones-copy-btn" onClick={copy} className="c-btn-primary px-3 py-2 text-xs flex items-center gap-1"><Copy className="w-3.5 h-3.5" /> Copiar</button>
      </div>
      <p className="text-xs c-muted px-1">Para invitar por WhatsApp abre un contacto en Red y toca "Invitar a CONECTA", o usa "Invitar varios" en la lista.</p>
      <Section title={`Historial (${d.items.length})`} testid="invitaciones-list">
        {d.items.length === 0 ? <p className="text-sm c-muted py-2">Todavía no envías invitaciones.</p> : (
          <ul className="divide-y c-line">
            {d.items.map((i) => (
              <li key={i.id} data-testid="invitacion-item" className="py-2.5 flex items-center justify-between gap-2 text-sm">
                <div className="min-w-0">
                  <p className="font-semibold truncate">{i.nuevo_usuario ? <Link to={`/conecta/u/${i.nuevo_usuario.id}`} className="c-accent">{i.nuevo_usuario.nombre_publico}</Link> : i.contacto || "Liga directa"}</p>
                  <p className="text-xs c-muted">{fmtDate(i.enviada_en?.slice(0, 10))} · {i.canal === "whatsapp" ? "WhatsApp" : "Liga"}</p>
                </div>
                <span data-testid="invitacion-status" className="text-xs px-2 py-0.5 rounded-full border c-line shrink-0">{status(i)}</span>
              </li>
            ))}
          </ul>
        )}
      </Section>
    </div>
  );
}
